module.exports = __webpack_public_path__ + "assets/img/23.8e1ff630.png";